import { IDictionary } from '~utilities/IDictionary';
import IncomeTrustClassTypeEnum from './IncomeTrustClassTypeEnum';

const IncomeTrustClassTypeLabels: IDictionary<string> = {
    [IncomeTrustClassTypeEnum.ClassC]: '6 Month',
    [IncomeTrustClassTypeEnum.ClassD]: '12 Month',
};

export default IncomeTrustClassTypeLabels;
